
import React from "react";
import { LucideIcon } from "lucide-react";

interface FeatureHighlightProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

export const FeatureHighlight = ({ title, description, icon }: FeatureHighlightProps) => {
  return (
    <div className="bg-savyi-purple/5 rounded-xl p-6 transition-all duration-300 hover:shadow-md">
      <div className="w-12 h-12 rounded-full bg-savyi-purple/10 flex items-center justify-center text-savyi-purple mb-4">
        {icon}
      </div>
      <h4 className="text-lg font-bold mb-2">{title}</h4>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};
